'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _join = require('lodash/join');

var _join2 = _interopRequireDefault(_join);

var _omitBy = require('lodash/omitBy');

var _omitBy2 = _interopRequireDefault(_omitBy);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _applicationState = require('./applicationState');

var _targetBuilder = require('./targetBuilder');

var _targetBuilder2 = _interopRequireDefault(_targetBuilder);

var _adsSettings = require('./adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

var _constants = require('../ads/constants');

var _mediaConstants = require('../ads/media/mediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function objectToQueryString(object) {
  return (0, _join2.default)((0, _map2.default)(object, function (value, key) {
    return key + '=' + value;
  }), '&');
}

function filterUndefinedValues(object) {
  return (0, _omitBy2.default)(object, _isUndefined2.default);
}

var networkUrlBuilder = {
  buildAdswizzUrl: function buildAdswizzUrl(partnerId, options, ccpaStatus) {
    var adswizzUrl = _url2.default.parse(_constants.ADSWIZZ_REQUEST_URL);
    var targetingInfo = _targetBuilder2.default.build();

    // pull lotame audience data - this goes in a separate param from the others
    var lotamesegments = void 0;
    if (targetingInfo.lotamesegments) {
      if (!(0, _isEmpty2.default)(targetingInfo.lotamesegments)) {
        lotamesegments = ';' + (0, _join2.default)(targetingInfo.lotamesegments, ';') + ';';
      }
      delete targetingInfo.lotamesegments;
    }

    // map targeting to &= delimited name/value pairs
    var tagsQueryString = objectToQueryString(targetingInfo);

    var zoneId = options ? options['ads.adswizz.zoneId'] : '590';
    var companionZones = options ? options['ads.adswizz.companionZones'] : '591;1342';
    var requestParams = {
      zoneId: zoneId,
      companionZones: companionZones,
      protocolVersion: '2.0-compliant',
      reqType: 'AdsSetup',
      companionAds: _adsSettings2.default.canShowCompanionAds() ? 'true' : 'false',
      tagsArray: tagsQueryString,
      stationId: targetingInfo.stationId,
      programId: targetingInfo.programId,
      topicId: targetingInfo.topicId,
      unlockEnabled: targetingInfo.unlockEnabled,
      isUnlocked: targetingInfo.isUnlocked,
      isLoggedIn: targetingInfo.isLoggedIn,
      'aw_0_1st.playerid': partnerId,
      'aw_0_1st.skey': '2112133398',
      'aw_0_1st.lotamesegments': lotamesegments,
      us_privacy: ccpaStatus,
      ppid: (0, _applicationState.getState)(_applicationState.State.ppid)
    };

    var _getState = (0, _applicationState.getState)(_applicationState.State.gdprData),
        gdprApplies = _getState.gdprApplies,
        tcString = _getState.tcString,
        isOptedOutOfGdpr = _getState.isOptedOut;

    if (gdprApplies) {
      var isOneTrustEnabled = (0, _get2.default)((0, _applicationState.getState)(_applicationState.State.options), 'ads.onetrust.gdpr.consent.form.enabled');

      if (isOneTrustEnabled) {
        requestParams[_constants.ADSWIZZ_GDPR_TCFV2_TCSTRING_PARAMETER] = tcString;
      } else {
        requestParams[_constants.ADSWIZZ_GDPR_CONSENT_PARAMETER] = !isOptedOutOfGdpr;
      }
    }

    adswizzUrl.query = filterUndefinedValues(requestParams);

    return _url2.default.format(adswizzUrl);
  },
  buildTargetingParams: function buildTargetingParams() {
    var targetingInfo = _targetBuilder2.default.build();

    return objectToQueryString(targetingInfo);
  },
  getInstreamCustomParams: function getInstreamCustomParams() {
    var targetingParams = this.buildTargetingParams().concat('&audioEnabled=true');

    // TUNE-12025: the adswizz listener id and global function are set internally by the AdsWizz SDK
    // scripts in prerollAdController.js
    var adswizzListenerId = window.com_adswizz_synchro_getListenerId && window.com_adswizz_synchro_getListenerId();

    if (adswizzListenerId) {
      targetingParams += '&listenerId=' + adswizzListenerId;
    }

    return encodeURIComponent(targetingParams);
  },
  buildDfpUrl: function buildDfpUrl(_ref, ccpaStatus) {
    var adUnitId = _ref.adUnitId,
        videoEnabled = _ref.videoEnabled;

    var dfpUrl = _url2.default.parse('https://pubads.g.doubleclick.net/gampad/ads');
    var targetingParams = this.buildTargetingParams();
    var videoEnabledParams = videoEnabled ? '&videoEnabled=true' : '&videoEnabled=false';

    var _getState2 = (0, _applicationState.getState)(_applicationState.State.gdprData),
        gdprApplies = _getState2.gdprApplies,
        tcString = _getState2.tcString;

    var custParams = targetingParams.concat('&audioEnabled=true').concat(videoEnabledParams);

    var requestParams = _extends(_defineProperty({
      ad_type: 'audio_video',
      output: 'vast',
      iu: adUnitId,
      impl: 's',
      gdfp_req: '1',
      env: 'vp',
      unviewed_position_start: '1',
      sz: videoEnabled ? _mediaConstants.prerollVideoAdUnitSizes : _mediaConstants.adPixelUnitSize,
      ciu_szs: '728x90,300x250,300x600',
      correlator: Date.now(),
      cust_params: custParams,
      us_privacy: ccpaStatus,
      ppid: (0, _applicationState.getState)(_applicationState.State.ppid)

    }, _constants.DFP_GDPR_NON_PERSONALIZED_ADS_PARAMETER, (0, _applicationState.getState)(_applicationState.State.isOptedOut) ? 1 : 0), (0, _applicationState.getState)(_applicationState.State.dfpParams, {}));

    if ((0, _isBoolean2.default)(gdprApplies)) {
      requestParams.gdpr = gdprApplies ? 1 : 0;
    }

    if (tcString) {
      requestParams.gdpr_consent = tcString;
    }

    dfpUrl.query = filterUndefinedValues(requestParams);

    return _url2.default.format(dfpUrl);
  }
};

module.exports = networkUrlBuilder;